function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconDownloadRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4 26h24v-5h2v5c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-5h2v5zm16-11h4l-7.274 7.677a.994.994 0 01-.736.323.995.995 0 01-.738-.325L8 15h4V7h8v8zm-6 2h-1.36l3.351 3.545L19.35 17H18V9h-4v8zm6-14v2h-8V3h8z",
    fill: props.color
  }));
}

export default SvgIconDownloadRexOutline;